import React from 'react';
import Icon from '../../shared/Icon';
import '../../Library/Library.css'; // the Library's empty state
import './Scenarios.css';

/** No scenarios at all yet (PRD-1701): the handoff's empty state, inside the panel. */
function ScenariosEmpty({ onAdd }) {
  return (
    <div className="library-empty scenarios-empty">
      <Icon name="link" size={32} className="library-empty-icon" />
      <h3 className="library-empty-title">No scenarios yet</h3>
      <p className="library-empty-note">Build one from a reference key in the library.</p>
      <button type="button" className="resui-btn resui-btn--primary" onClick={onAdd}>Add scenario</button>
    </div>
  );
}

export default ScenariosEmpty;
